export const FETCH_EMP_ALLOCATION_CDLJOBS_REQUEST = "FETCH_EMP_ALLOCATION_CDLJOBS_REQUEST";
export const FETCH_EMP_ALLOCATION_CDLJOBS_SUCCESS = "FETCH_EMP_ALLOCATION_CDLJOBS_SUCCESS";
export const FETCH_EMP_ALLOCATION_CDLJOBS_FAILURE = "FETCH_EMP_ALLOCATION_CDLJOBS_FAILURE";